import React from 'react';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCreditCard, faMoneyCheckAlt } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

function PublicPaymentSuccessModal(props) {

    return (
        <Modal isOpen={props.open} toggle={props.toggle} keyboard={false} backdrop={'static'}>
            <ModalHeader>
                Payment Successful
            </ModalHeader>
            <ModalBody>
                <div>
                    Your payment was processed successfully.
                </div>
            </ModalBody>
            <ModalFooter>
                <Link className="button btn btn-danr-green" color="danr-green" to="/home"><span>OK</span></Link>
            </ModalFooter>
        </Modal>
    );
}

export default PublicPaymentSuccessModal;